import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import UserBasicInfoContext from '../../../../components/Context/UserBasicInfoContext';
import { SUPER_ADMIN_CODE } from '../../ConstRole/ConstRole';

const PartnerRegistrationInfo = ({ companyDetails }) => {

    const userProfile = useContext(UserBasicInfoContext);

    return (
        <>
            {(companyDetails) &&
                <div className=" w-full pb-10 pt-0">

                    <h1 className="font-bold text-lg mb-3 px-2">Basic Information</h1>

                    <table className="custom-details-table w-full mt-0 mb-2">
                        <tbody>
                            <tr>
                                <td className="font-semibold text-base">Doing Business As</td>
                                <td className="px-5 text-base">
                                    {companyDetails.name}

                                    {((userProfile?.user_type_id === SUPER_ADMIN_CODE) && (companyDetails?.name?.length > 0) ) && 
                                    <Link to={"/dashboard/company/edit-company"} state={{ data: companyDetails }} className="ml-3 py-1 px-2 justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-xs dark:focus:ring-offset-gray-800">
                                        Edit
                                    </Link>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Company Name</td>
                                <td className="px-5 text-base">{companyDetails.name2}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">
                                    Business Category
                                </td>
                                <td className="px-5 text-base">{companyDetails.category?.name}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">
                                    Logo
                                </td>
                                <td className="px-5 text-base">
                                    <div className='flex items-center'>
                                        {(companyDetails.logo) &&
                                            <img src={companyDetails.logo} alt="Business Logo" className='max-h-[100px] max-w-sm float-left mr-6 py-3' />
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">
                                    Banner
                                </td>
                                <td className="px-5 text-base">
                                    <div className='flex items-center'>
                                        {(companyDetails.banner_image) &&
                                            <img src={companyDetails.banner_image} alt="Banner" className='max-h-[100px] max-w-sm float-left mr-6 py-3' />
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base" title="As Per Trade License">Address (TL)</td>
                                <td className="px-5 text-base">{companyDetails.address}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Current Address</td>
                                <td className="px-5 text-base">{companyDetails.current_address}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Phone</td>
                                <td className="px-5 text-base">{companyDetails.mobile_no}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Email</td>
                                <td className="px-5 text-base">{companyDetails.email}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Settlement Charge</td>
                                <td className="px-5 text-base">{companyDetails?.commission} {(companyDetails?.commission_type === 1) && <strong>%</strong> }</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Settlement Cycle</td>
                                <td className="px-5 text-base">{companyDetails?.settlement_cycle}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Service Type</td>
                                <td className="px-5 text-base">{companyDetails?.service_type}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Position</td>
                                <td className="px-5 text-base">{companyDetails?.position}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>}

                <style jsx={true}>{`
                table.custom-details-table tr td:first-child {
                    width: 300px;
                }
                `}</style>
        </>
    );
};

export default PartnerRegistrationInfo;